import { render } from "./ComponentFeedbackModal.vue?vue&type=template&id=24cb8b7e&scoped=true"
import script from "./ComponentFeedbackModal.vue?vue&type=script&lang=js"
export * from "./ComponentFeedbackModal.vue?vue&type=script&lang=js"

import "./ComponentFeedbackModal.vue?vue&type=style&index=0&id=24cb8b7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cb8b7e"]])

export default __exports__